import _ from 'lodash';
import Ajv from 'ajv';
import i18next from 'i18next';

import ConfirmationModal from '../../../components/ConfirmationModal';
import PropsEditorModal from '../../../components/PropsEditorModal';

const ajv = new Ajv();

export const getPropsEditorModalConfig = ({
  cashierConfig,
  props,
  schema,
  onPropsChange,
  handleSavePropsCashierConfig,
}) => {
  const validate = ajv.compile(schema);

  const valid = validate(props);

  return {
    type: 'action',
    width: '600px',
    height: 'auto',
    icon: '/images/inpulse/gear-black-small.svg',
    title: i18next.t('BACKOFFICE.CASHIERS.HANDLE_PROPS_ACTION'),
    component: PropsEditorModal,
    data: {
      json: props,
      schema: schema,
      onChange: (value) => onPropsChange(cashierConfig, value),
      description: _.get(cashierConfig, 'lnkCashierCashierConfig.description'),
    },
    actions: [
      {
        key: 0,
        color: 'inpulse-outline',
        label: i18next.t('GENERAL.CANCEL'),
        icon: '/images/inpulse/close-black-small.svg',
      },
      {
        key: 1,
        isDisabled: !valid,
        color: 'inpulse-default',
        label: i18next.t('GENERAL.SAVE'),
        icon: '/images/inpulse/save-white-small.svg',
        handleClick: () => handleSavePropsCashierConfig(cashierConfig),
      },
    ],
  };
};

export const getDeleteCashierConfigModalConfig = ({
  cashierConfig,
  handleDeleteCashierConfigById,
}) => ({
  type: 'warning',
  width: '542px',
  height: 'auto',
  icon: '/images/inpulse/trash-white-small.svg',
  title: i18next.t('BACKOFFICE.CASHIERS.DELETE_CASHIER_CONFIG_ACTION'),
  component: ConfirmationModal,
  data: {
    content: i18next.t('BACKOFFICE.CASHIERS.DELETE_CASHIER_CONFIG_CONTENT', {
      cashierConfigName: cashierConfig.name,
    }),
  },
  actions: [
    {
      key: 0,
      color: 'inpulse-outline',
      label: i18next.t('GENERAL.CANCEL'),
      icon: '/images/inpulse/close-black-small.svg',
    },
    {
      key: 1,
      color: 'inpulse-default',
      label: i18next.t('GENERAL.DELETE'),
      icon: '/images/inpulse/trash-white-small.svg',
      handleClick: () => handleDeleteCashierConfigById(cashierConfig.id),
    },
  ],
});

export default {
  getPropsEditorModalConfig,
  getDeleteCashierConfigModalConfig,
};
